import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";

interface SkeltonLoaderList {
  maxWidth?: number;
  maxHeight?: number;
  style?: any;
}
export default function SkeltonLoader({ maxWidth = 350, maxHeight, style }: SkeltonLoaderList) {
  return (
    <Card
      sx={{
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        mt: 5,
        border: "none",
        boxShadow: "none",
      }}
      style={style}>
      <Skeleton sx={{ height: 190, marginBottom: 2 }} animation='wave' variant='rectangular' />
      <Skeleton animation='wave' width='40%' height={15} style={{ marginBottom: 15 }} />
      <Skeleton animation='wave' height={10} width='80%' style={{ marginBottom: 6 }} />
      <Skeleton animation='wave' height={10} width='80%' style={{ marginBottom: 6 }} />
    </Card>
  );
}
